import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rMadenSahalariGenelBilgi, rValue } from '../../models/.catalog';

export default class MadenSahalariGenelBilgiApi extends ApiBase<
  pList,
  rValue<rMadenSahalariGenelBilgi>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/MadenSahalariGenelBilgi',
      }),
      options
    );
  }
}
